<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="card-gis-filter">
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="1">
              <div class="row mt-3">
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                  <label>{{ $t('common_words.farm') }} *</label>
                  <br />
                  <el-select
                    clearable
                    v-bind:collapse-tags="true"
                    filterable
                    class="select-primary custom-width-select required-farm shadow-sm"
                    size="large"
                    v-model="formData.farm_id"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in farms"
                      class="select-primary"
                      :value="option.id"
                      :label="option.name"
                      :key="index + option.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                  <label for="">{{ $t('common_words.date') }}: </label>
                  <el-date-picker
                    v-if="renderComponent"
                    :picker-options="pickerOptions"
                    class="shadow-sm required-date"
                    v-model="formData.date_sel"
                    type="date"
                    range-separator="-"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                  </el-date-picker>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                  <label>{{ $t('climate.cloud_coverage') }}*</label>
                  <br />
                  <el-select
                    clearable
                    v-bind:collapse-tags="true"
                    filterable
                    class="select-primary custom-width-select required-type shadow-sm"
                    size="large"
                    v-model="formData.cover_cloud"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in optionsCloudCover"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="index"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-12 col-md-4 col-xl-2">
                  <label class="label-primary" style="color: transparent">{{
                    $t('common_words.filter')
                  }}</label
                  ><br />
                  <l-button
                    wide
                    type="info"
                    class="btn-filter"
                    @click="validate"
                  >
                    {{ $t('common_words.filter') }}
                  </l-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </card>
        <div class="row">
          <div class="col-12 map-climate">
            <div
              ref="map"
              class="map"
              v-if="renderComponent"
              style="height: 800px"
            ></div>
            <div
              id="toolbarDiv"
              class="esri-component esri-widget"
              v-if="renderComponent"
            >
              <button
                id="distance"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                style="margin-bottom: 10px"
                :title="$t('common_words.distance_measurement_tool')"
              ></button>
              <button
                id="area"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                style="margin-bottom: 10px"
                :title="$t('common_words.area_measurement_tool')"
              ></button>
              <button
                id="clear"
                class="action-button esri-widget--button esri-interactive esri-icon-trash"
                style="margin-bottom: 10px"
                :title="$t('common_words.clear_measurement')"
              ></button>

              <button
                v-if="this.download"
                id="dowloandButton"
                class="action-button esri-widget--button esri-interactive esri-icon-download"
                style="margin-bottom: 10px; border: none"
                :title="$t('common_words.download_file')"
                @click="downloadFile"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import moment from 'moment';
import { mapActions } from 'vuex';
import SweetAlert from 'src/class/Alerts';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { Checkbox } from 'element-ui';
import MixinMenu from 'src/util/mixinMenu';
import axios from 'axios';
import alert from 'sweetalert2';

export default {
  components: {
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      center: {
        lat: 10.947212,
        lng: -74.203901717,
      },
      activeName: '1',
      formData: {
        cover_cloud: null,
        farm_id: null,
        allFarms: false,
        date_sel: new Date(moment().format('YYYY-MM-DD').replace(/-/, '/')),
      },
      group: [1],
      renderComponent: true,
      reports: null,
      optionsCloudCover: {
        0: { label: '1 %', value: '0.01' },
        1: { label: '2 %', value: '0.02' },
        2: { label: '3 %', value: '0.03' },
        3: { label: '4 %', value: '0.04' },
        4: { label: '5 %', value: '0.05' },
        5: { label: '6 %', value: '0.06' },
        6: { label: '7 %', value: '0.07' },
        7: { label: '8 %', value: '0.08' },
        8: { label: '9%', value: '0.09' },
        9: { label: '10%', value: '0.1' },
      },
      farms: [],
      farm_name: null,
      mapData: {},
      kmlLayer: null,
      map: null,
      download: false,
      valueCollapse: null,
    };
  },
  computed: {
    avaliableYears() {
      let currentYear = new Date();
      let previousYear = new Date();

      currentYear = currentYear.getFullYear();
      previousYear = previousYear.getFullYear() - 1;

      return [currentYear, previousYear];
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  mixins: [
    MixinPermissions,
    MixinArcgisMap,
    MixinDatePicker,
    mixinMasters,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    validate() {
      if (this.formData.farm_id == null) {
        return this.validationInputsRequired('farm');
      } else if (this.formData.cover_cloud == null) {
        return this.validationInputsRequired('type');
      } else {
        this.loadReport();
      }
    },

    loadReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'gis/satellite/satelliteImg';
      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.download = response.data.data;
            this.loadMap();
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
        });
    },

    downloadFile() {
      SweetAlert.download('Espere mientras los Archivos se descarga.', alert);
      let data = this.loadData();
      data.route = '/auth/gis/satellite/downloadFile';
      return axios({
        url: data.route,
        data: data,
        method: 'POST',
        responseType: 'arraybuffer',
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            'archivos_Finca_' + this.farm_name.replaceAll(' ', '_') + '_.zip'
          );
          document.body.appendChild(link);
          link.click();
          this.showDownloadNotification();
          alert.close();
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
        });
    },

    loadData() {
      let data = {
        farm: this.formData.farm_id,
        cover_cloud: this.formData.cover_cloud,
        date_sel: this.formData.date_sel,
      };
      return data;
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },

    loadMap() {
      this.renderComponent = false;
      this.showHideLoading(true);
      let namesFiles = [];
      let centers = [];
      if (this.formData.farm_id != 0 && this.formData.farm_id !== null) {
        for (let index = 0; index < this.farms.length; index++) {
          if (this.farms[index].id == this.formData.farm_id) {
            this.center = {
              lat: this.farms[index].latitude,
              lng: this.farms[index].longitude,
            };
            centers.push(this.center);
            this.farm_name = this.farms[index].name;
            if (
              this.farms[index].other_values &&
              JSON.parse(this.farms[index].other_values).files
            ) {
              JSON.parse(this.farms[index].other_values).files.forEach(
                (element) => {
                  namesFiles.push(this.farms[index].id + '/' + element);
                }
              );
            }
          }
        }
      }

      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadMapMultipleC(namesFiles, true, false, centers);
        this.showHideLoading();
        setTimeout(() => {
          document.getElementById('toolbarDiv').style =
            'top: 19% !important;right: 30px;';
        }, 10);
      });
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/only')
        .then((response) => {
          this.farms = response.data.data;
          this.loadMap();

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('gis');
  },

  destroyed() {
    this.deselectedItemOnMenu('gis');
  },
};
</script>

<style scoped>
#toolbarDiv {
  top: 12% !important;
  margin-top: 0px;
  padding-top: 0px;
}
</style>
